import React from "react";
import { FoodGroupDashboard } from "../../../../components/FoodGroup/Dashboard";

export const FoodGroupsPage = () => <FoodGroupDashboard />;
